import React, { useState, useEffect } from "react";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/Footer/footer";
import imageCompany from "../../assets/company.png";
import axios from 'axios';
import 'remixicon/fonts/remixicon.css';
import { toast, ToastContainer } from 'react-toastify';
import Select from "react-select";
const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    countryId: null,
    message: "",
    userType: ""
  });
  const [countries, setCountries] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [ipAddress, setIpAddress] = useState("");
  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setIpAddress(response.data.ip);
      } catch (error) {
        console.error("Error fetching IP address:", error);
        setIpAddress("Unable to fetch IP"); // Fallback in case of error
      }
    };

    fetchIpAddress();
  }, []);
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get("https://crmprodapi.guideuni.com/GetCountries");

        const countryOptions = response.data.map(c => ({
          value: c.countryID,
          label: c.countryName,
          countryCode: c.countryCode,
          countryName: c.countryName,
        }));

        setCountries(countryOptions);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);
  const formatOptionLabel = ({ countryCode, countryName, dial }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <img
        src={require(`../../assets/countrylogos/${countryCode?.trim().toLowerCase()}.png`)}
        alt={countryName}
        style={{ width: '20px', marginRight: '10px' }}
      />
      {countryName}
    </div>
  );
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      id: 0,
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      country: formData.countryId,
      message: formData.message,
      type: formData.userType,
      ipAddress: ipAddress, // Use the dynamically fetched IP address
      macAddress: 'Null',
      website: "FlyUrDream.pk",
      createdOn: new Date().toISOString(),
      isActive: true,
    };
    console.log('before', payload)
    try {
      setIsLoading(true);
      const response = await axios.post('https://crmprodapi.guideuni.com/AddFlyurdreamEnquiry', payload);
      toast.success(response.data.message)
      setFormData({
        name: "",
        email: "",
        phone: "",
        countryId: null,
        message: "",
      });
      console.log('after', response.data)
    } catch (error) {
      toast.error("Error submitting enquiry:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div class="header">
      <Navbar />
      <div class="inner-banner-section">
        <div class="inner-banner-mask"></div>
        <img src={imageCompany} alt="Company" class="img-fluid" />
        <div class="inner-banner-caption">
          <h2 class="display-5">Contact Us - Fly Ur Dream</h2>
          <p>Have Questions?<br />
            Don't Hesitate to Contact Us
          </p>
        </div>
      </div>
      <div class="osc-section pt-5 pb-5">
        <div class="container-fluid">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <div class="section-title">
                  <h2 class="display-5">Connecting
                    <span class="text-c-2">Worldwide</span></h2>
                </div>
                <p class="text-center">
                  At FlyUrDream, we are dedicated to transforming students’ aspirations into reality by providing comprehensive support throughout their international education journey. Our mission is to simplify the complexities of studying abroad, ensuring that every student has access to quality education opportunities worldwide.
                </p>
              </div>
            </div>


          </div>
        </div>
      </div>
      <div class="common-section pt-5">
        <div class="container-fluid">
          <div class="container">

            <div class="row">
              <div class="col-md-6 col-sm-12">


                <h4 class="display-6">Opening Hour
                </h4>
                <address>
                  <b>  Monday:</b> <span class='time-common'>10.00 am to 06.00 pm</span>
                </address>
                <address>
                  <b>  Tuesday:</b> <span class='time-common'>10.00 am to 06.00 pm</span>
                </address>
                <address>
                  <b>  Wednesday:</b>  <span class='time'>10.00 am to 06.00 pm</span>
                </address>
                <address>
                  <b>  Thrusday:</b>  <span class='time-common2'>10.00 am to 06.00 pm</span>
                </address>
                <address>
                  <b>  Friday:</b>  <span class='time-common3'>10.00 am to 06.00 pm</span>
                </address>
                <address>
                  <b>  Saturday:</b>  <span class='time-common2'>10.00 am to 06.00 pm</span>
                </address>
                <address>
                  <b>  Sunday:</b>  <span class='time-common1'>10.00 am to 06.00 pm</span>
                </address>

              </div>
              <div class="col-md-6 col-sm-12">
                Let’s Connect
                <h4 class="display-6">Send Your Message
                </h4>
                <p>Please feel free to get in touch with us using the contact form below.

                </p>

                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col">
                      <label className="form-label">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        placeholder="Name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col">
                      <label className="form-label">Phone</label>
                      <input
                        type="text"
                        className="form-control"
                        name="phone"
                        placeholder="Phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col">
                      <label className="form-label">Country</label>
                      <Select
                        options={countries}
                        value={countries.find(c => c.label === formData.countryId) || null}
                        onChange={(selected) =>
                          setFormData({ ...formData, countryId: selected?.label || null })
                        }
                        formatOptionLabel={formatOptionLabel}
                        placeholder="Choose Country"
                      />
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="radio-contact">
                      <label className="form-label">User Type</label>
                      <div>
                        <input
                          type="radio"
                          name="userType"
                          value="Student"
                          checked={formData.userType === "Student"}
                          onChange={handleChange}
                        />
                        <label className="ms-2">Student</label>
                      </div>
                      <div>
                        <input
                          type="radio"
                          name="userType"
                          value="Recruiter"
                          checked={formData.userType === "Recruiter"}
                          onChange={handleChange}
                        />
                        <label className="ms-2">Recruiter</label>
                      </div>
                      <div>
                        <input
                          type="radio"
                          name="userType"
                          value="Other"
                          checked={formData.userType === "Other"}
                          onChange={handleChange}
                        />
                        <label className="ms-2">Other</label>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col">
                      <label className="form-label">Message</label>
                      <textarea
                        className="form-control"
                        name="message"
                        placeholder="Message"
                        value={formData.message}
                        onChange={handleChange}
                        style={{ height: "100px" }}
                        required
                      ></textarea>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col">
                      <button type="submit" className="btn btn-primary">
                        {isLoading ? (
                          <span>Submitting...</span>
                        ) : (
                          <span>
                            <i className="ri-telegram-2-fill"></i>  Submit
                          </span>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

          </div>
        </div>
        <ToastContainer />
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
